import script from "./TimeOut.vue?vue&type=script&setup=true&lang=js"
export * from "./TimeOut.vue?vue&type=script&setup=true&lang=js"

import "./TimeOut.vue?vue&type=style&index=0&id=d47b3948&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d47b3948"]])

export default __exports__